/**
 * avatars/items/wings.js
 * Xây dựng hình học 3D cho createWings
 */

import * as THREE from 'three';
import { WING_TYPES } from './item-types.js';

export { WING_TYPES };

export function createWings(lib, type, torsoW, torsoH, torsoD, wingColor = '#ffffff') {
  const wingGroup = new THREE.Group();
  wingGroup.name = `Wings_${type}`;

  if (!type || type === 'none') return wingGroup;

  const wingMat = new THREE.MeshStandardMaterial({
    color: wingColor,
    roughness: 0.6,
    side: THREE.DoubleSide
  });
  lib.disposables.push(wingMat);

  if (type === 'angel_wings') {
    // ĐÔI CÁNH THIÊN SỨ LÔNG VŨ VOXEL 3 TẦNG SO LE THANH THOÁT, VÁT CONG MỀM MẠI
    const goldTrimMat = new THREE.MeshStandardMaterial({ color: '#facc15', metalness: 0.85, roughness: 0.25 });
    const softFeatherMat = new THREE.MeshStandardMaterial({ color: wingColor || '#ffffff', roughness: 0.45 });
    lib.disposables.push(goldTrimMat, softFeatherMat);

    [-1, 1].forEach((side) => {
      const wingArm = new THREE.Group();
      wingArm.position.set(side * torsoW * 0.38, torsoH * 0.82, -torsoD * 0.52);

      // Khung sườn cánh uốn cong hình cánh cung
      const bone1Geo = new THREE.BoxGeometry(torsoW * 0.65, 0.045, 0.035);
      const bone1 = new THREE.Mesh(bone1Geo, softFeatherMat);
      bone1.position.set(side * torsoW * 0.28, 0.16, -0.04);
      bone1.rotation.set(0, -side * 0.2, side * 0.35);
      wingArm.add(bone1);

      const bone2Geo = new THREE.BoxGeometry(torsoW * 0.45, 0.035, 0.03);
      const bone2 = new THREE.Mesh(bone2Geo, goldTrimMat);
      bone2.position.set(side * torsoW * 0.62, 0.28, -0.07);
      bone2.rotation.set(0, -side * 0.35, side * 0.7);
      wingArm.add(bone2);

      // Tầng 1: Lông vũ nhỏ mịn áp sát lưng (3 lông)
      for (let i = 0; i < 3; i++) {
        const fGeo = new THREE.BoxGeometry(0.065, torsoH * (0.35 - i * 0.04), 0.015);
        const f = new THREE.Mesh(fGeo, softFeatherMat);
        f.position.set(side * (0.1 + i * 0.09), 0.02 - i * 0.05, -0.06 - i * 0.02);
        f.rotation.set(0.08, -side * 0.15, side * (0.12 + i * 0.06));
        wingArm.add(f);
        lib.disposables.push(fGeo);
      }

      // Tầng 2: Lông vũ trung gian xòe rộng (4 lông)
      for (let i = 0; i < 4; i++) {
        const fGeo = new THREE.BoxGeometry(0.075, torsoH * (0.55 - i * 0.05), 0.015);
        const f = new THREE.Mesh(fGeo, softFeatherMat);
        f.position.set(side * (0.22 + i * 0.11), 0.1 - i * 0.07, -0.08 - i * 0.03);
        f.rotation.set(0.12, -side * 0.25, side * (0.28 + i * 0.08));
        wingArm.add(f);
        lib.disposables.push(fGeo);
      }

      // Tầng 3: Lông vũ dài vút bay bổng ngoài cùng (4 lông mũi nhọn viền vàng)
      for (let i = 0; i < 4; i++) {
        const isTip = i === 0 || i === 3;
        const fGeo = new THREE.BoxGeometry(0.08, torsoH * (0.78 - i * 0.07), 0.016);
        const f = new THREE.Mesh(fGeo, isTip ? goldTrimMat : softFeatherMat);
        f.position.set(side * (0.36 + i * 0.13), 0.2 - i * 0.09, -0.11 - i * 0.04);
        f.rotation.set(0.16, -side * 0.32, side * (0.45 + i * 0.1));
        wingArm.add(f);
        lib.disposables.push(fGeo);
      }

      wingGroup.add(wingArm);
      lib.disposables.push(bone1Geo, bone2Geo);
    });
  } else if (type === 'dragon_wings') {
    // ĐÔI CÁNH RỒNG VOXEL ĐA NAN XƯƠNG & MÀNG DA CONG 3 KHỐI THANH THOÁT
    const boneMat = new THREE.MeshStandardMaterial({
      color: '#450a0a',
      roughness: 0.5,
      metalness: 0.2
    });
    const wingMemMat = new THREE.MeshPhysicalMaterial({
      color: wingColor || '#991b1b',
      roughness: 0.35,
      metalness: 0.1,
      transmission: 0.3,
      transparent: true,
      opacity: 0.88,
      side: THREE.DoubleSide
    });
    const clawMat = new THREE.MeshStandardMaterial({ color: '#f59e0b', roughness: 0.3 });
    lib.disposables.push(boneMat, wingMemMat, clawMat);

    [-1, 1].forEach((side) => {
      const wingArm = new THREE.Group();
      wingArm.position.set(side * torsoW * 0.4, torsoH * 0.82, -torsoD * 0.52);

      // Khớp cánh chính vươn lên cao
      const b1Geo = new THREE.BoxGeometry(0.045, torsoH * 0.72, 0.045);
      const b1 = new THREE.Mesh(b1Geo, boneMat);
      b1.position.set(side * torsoW * 0.24, torsoH * 0.3, -0.06);
      b1.rotation.set(-0.15, side * 0.25, side * 0.55);
      wingArm.add(b1);

      // Cựa rồng nhọn tại đỉnh khuỷu cánh
      const clawGeo = new THREE.BoxGeometry(0.025, 0.08, 0.025);
      const claw = new THREE.Mesh(clawGeo, clawMat);
      claw.position.set(side * torsoW * 0.45, torsoH * 0.64, -0.1);
      claw.rotation.set(-0.3, side * 0.2, side * 0.85);
      wingArm.add(claw);

      // 3 Nan xương ngón cánh xòe ra sau
      const fingerParams = [
        {
          len: torsoH * 0.65,
          rotZ: side * 0.15,
          rotY: -side * 0.2,
          posX: side * torsoW * 0.52,
          posY: torsoH * 0.52,
          posZ: -0.12
        },
        {
          len: torsoH * 0.55,
          rotZ: -side * 0.1,
          rotY: -side * 0.25,
          posX: side * torsoW * 0.58,
          posY: torsoH * 0.38,
          posZ: -0.14
        },
        {
          len: torsoH * 0.45,
          rotZ: -side * 0.35,
          rotY: -side * 0.3,
          posX: side * torsoW * 0.62,
          posY: torsoH * 0.22,
          posZ: -0.16
        }
      ];

      fingerParams.forEach((fp) => {
        const fGeo = new THREE.BoxGeometry(0.025, fp.len, 0.025);
        const f = new THREE.Mesh(fGeo, boneMat);
        f.position.set(fp.posX, fp.posY, fp.posZ);
        f.rotation.set(0.1, fp.rotY, fp.rotZ);
        wingArm.add(f);
        lib.disposables.push(fGeo);
      });

      // 3 Màng cánh rồng bán trong suốt lượn giữa các nan xương
      const memGeo1 = new THREE.BoxGeometry(torsoW * 0.38, torsoH * 0.5, 0.01);
      const m1 = new THREE.Mesh(memGeo1, wingMemMat);
      m1.position.set(side * torsoW * 0.36, torsoH * 0.42, -0.1);
      m1.rotation.set(0.08, -side * 0.15, side * 0.32);
      wingArm.add(m1);

      const memGeo2 = new THREE.BoxGeometry(torsoW * 0.34, torsoH * 0.42, 0.01);
      const m2 = new THREE.Mesh(memGeo2, wingMemMat);
      m2.position.set(side * torsoW * 0.52, torsoH * 0.34, -0.13);
      m2.rotation.set(0.1, -side * 0.22, side * 0.05);
      wingArm.add(m2);

      const memGeo3 = new THREE.BoxGeometry(torsoW * 0.3, torsoH * 0.34, 0.01);
      const m3 = new THREE.Mesh(memGeo3, wingMemMat);
      m3.position.set(side * torsoW * 0.58, torsoH * 0.2, -0.15);
      m3.rotation.set(0.12, -side * 0.28, -side * 0.18);
      wingArm.add(m3);

      wingGroup.add(wingArm);
      lib.disposables.push(b1Geo, clawGeo, memGeo1, memGeo2, memGeo3);
    });
  } else if (type === 'insect_wings') {
    // CÁNH BỌ KITIN TRONG SUỐT GẬP SAU LƯNG
    const insectMat = new THREE.MeshPhysicalMaterial({
      color: wingColor || '#10b981',
      transparent: true,
      opacity: 0.65,
      roughness: 0.1,
      metalness: 0.2
    });
    lib.disposables.push(insectMat);

    [-1, 1].forEach((side) => {
      const wGeo = new THREE.BoxGeometry(torsoW * 0.45, torsoH * 1.1, 0.02);
      const w = new THREE.Mesh(wGeo, insectMat);
      w.position.set(side * torsoW * 0.26, torsoH * 0.35, -torsoD * 0.56);
      w.rotation.set(0.12, side * 0.1, side * 0.15);
      wingGroup.add(w);
      lib.disposables.push(wGeo);
    });
  } else if (type === 'fish_fin') {
    // VÂY LƯNG CÁ ĐẠI DƯƠNG 3D THANH MẢNH ĐA NAN SỤN PHÁT QUANG XÀ CỪ
    const cartilageMat = new THREE.MeshStandardMaterial({
      color: '#0891b2',
      roughness: 0.2,
      metalness: 0.4
    });
    const webMat = new THREE.MeshPhysicalMaterial({
      color: '#06b6d4',
      roughness: 0.1,
      metalness: 0.15,
      transmission: 0.65,
      transparent: true,
      opacity: 0.82,
      ior: 1.34,
      side: THREE.DoubleSide
    });
    const pearlGlowMat = new THREE.MeshBasicMaterial({
      color: '#a5f3fc'
    });
    lib.disposables.push(cartilageMat, webMat, pearlGlowMat);

    // 1. Cột sống sụn lưng 3D phân đoạn dọc cơ thể
    for (let s = 0; s < 5; s++) {
      const segH = torsoH * 0.18;
      const segGeo = new THREE.BoxGeometry(torsoW * 0.07, segH, torsoD * 0.14);
      const segMesh = new THREE.Mesh(segGeo, cartilageMat);
      segMesh.position.set(0, torsoH * (0.8 - s * 0.14), -torsoD * 0.52 - s * 0.01);
      segMesh.rotation.x = -0.05 * s;
      wingGroup.add(segMesh);
      lib.disposables.push(segGeo);
    }

    // 2. 5 Nan gai vây cá 3D cong vút ra sau và chếch lên trên (Fin Spines)
    const finSpines = [
      { len: torsoH * 0.68, y: torsoH * 0.82, z: -torsoD * 0.54, rotX: -0.58, w: 0.022 },
      { len: torsoH * 0.58, y: torsoH * 0.68, z: -torsoD * 0.55, rotX: -0.42, w: 0.02 },
      { len: torsoH * 0.46, y: torsoH * 0.52, z: -torsoD * 0.56, rotX: -0.28, w: 0.018 },
      { len: torsoH * 0.35, y: torsoH * 0.38, z: -torsoD * 0.57, rotX: -0.15, w: 0.016 },
      { len: torsoH * 0.24, y: torsoH * 0.25, z: -torsoD * 0.58, rotX: -0.05, w: 0.014 }
    ];

    finSpines.forEach((sp) => {
      const spineGeo = new THREE.BoxGeometry(sp.w, sp.len, sp.w);
      const spineMesh = new THREE.Mesh(spineGeo, cartilageMat);
      // Pivot tại gốc lưng
      spineMesh.position.set(0, sp.y + (sp.len / 2) * Math.cos(sp.rotX), sp.z + (sp.len / 2) * Math.sin(sp.rotX));
      spineMesh.rotation.x = sp.rotX;
      wingGroup.add(spineMesh);

      // Hạt ngọc phát quang sinh học tại đầu chóp mỗi nan gai
      const tipGeo = new THREE.SphereGeometry(0.018, 8, 8);
      const tipMesh = new THREE.Mesh(tipGeo, pearlGlowMat);
      tipMesh.position.set(0, sp.y + sp.len * Math.cos(sp.rotX), sp.z + sp.len * Math.sin(sp.rotX));
      wingGroup.add(tipMesh);

      lib.disposables.push(spineGeo, tipGeo);
    });

    // 3. Màng vây trong mờ 3D uốn cong giữa các cặp nan gai
    for (let m = 0; m < finSpines.length - 1; m++) {
      const sp1 = finSpines[m];
      const sp2 = finSpines[m + 1];

      const webH = (sp1.len + sp2.len) * 0.45;
      const webD = Math.abs(sp1.z - sp2.z) + torsoD * 0.35;
      const webGeo = new THREE.BoxGeometry(0.008, webH, webD);
      const webMesh = new THREE.Mesh(webGeo, webMat);

      const midY = (sp1.y + sp2.y) * 0.5 + webH * 0.35;
      const midZ = (sp1.z + sp2.z) * 0.5 - webD * 0.4;
      const midRotX = (sp1.rotX + sp2.rotX) * 0.5;

      webMesh.position.set(0, midY, midZ);
      webMesh.rotation.x = midRotX;
      wingGroup.add(webMesh);
      lib.disposables.push(webGeo);
    }
  } else if (type === 'aurora_ribbon') {
    // DẢI LỤA CỰC QUANG 3D UỐN LƯỢN SÓNG DẠ QUANG
    const auroraMat = new THREE.MeshPhysicalMaterial({
      color: wingColor || '#22d3ee',
      transparent: true,
      opacity: 0.8,
      roughness: 0.1,
      transmission: 0.6,
      side: THREE.DoubleSide
    });
    const auroraGlowMat = new THREE.MeshBasicMaterial({
      color: '#c084fc',
      transparent: true,
      opacity: 0.65,
      side: THREE.DoubleSide
    });
    lib.disposables.push(auroraMat, auroraGlowMat);

    [-1, 1].forEach((side) => {
      // Tạo 4 nếp uốn lượn hình sóng bồng bềnh
      for (let wave = 0; wave < 4; wave++) {
        const wH = torsoH * 0.35;
        const ribGeo = new THREE.BoxGeometry(0.065, wH, 0.012);
        const rib = new THREE.Mesh(ribGeo, wave % 2 === 0 ? auroraMat : auroraGlowMat);
        const curY = torsoH * (0.85 - wave * 0.24);
        const curZ = -torsoD * (0.58 + wave * 0.12);
        rib.position.set(side * (torsoW * 0.38 + wave * 0.04), curY, curZ);
        rib.rotation.set(0.18 + wave * 0.08, side * (0.2 + wave * 0.05), side * (0.15 - wave * 0.04));
        wingGroup.add(rib);
        lib.disposables.push(ribGeo);
      }
    });
  }

  return wingGroup;
}
